import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { Box, Heading, Flex, Button, Text, useToast } from "@chakra-ui/react";
import React from "react";
import { useFormContext } from "react-hook-form";
import { ITicket } from "../../../model";
import { useTranslation } from "react-i18next";

interface IProps {
  item: ITicket[];
  index: number;
}

export const TabPanelTicket = ({ item, index }: IProps) => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext();
  const getName = (i) => `eventTicketInfo.${index}.ticketInfo.${i}.quantity`;

  const toast = useToast();

  const maxQuantityCheck = (index, quantity) => {
    if (quantity === watch(getName(index))) {
      toast({
        title: `Only ${quantity} tickets left for this ticket`,
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      {item.map((item, i) => (
        <Box
          p={5}
          border="1px dashed #e2e2e2"
          borderRadius="10px"
          bg="gray.50"
          textAlign="center"
          key={item.id}
        >
          <Heading size="sm" mb={4}>
            #{t("ticket")} {i + 1}
          </Heading>
          <Box textAlign="left">
            <Text>
              <Box as="span" style={{ fontWeight: "bold" }}>
                {t("ticket-name")}:&nbsp;
              </Box>
              {item.ticketName}
            </Text>
            <Text>
              <Box as="span" style={{ fontWeight: "bold" }}>
                {t("description")}:&nbsp;
              </Box>
              {item.description}
            </Text>
            <Text>
              <Box as="span" style={{ fontWeight: "bold" }}>
                {t("date")}:&nbsp;
              </Box>
              {item.startDate}, {item.startTime}
            </Text>
            <Text fontWeight="bold">
              {t("price")}: {item.price ?? 0} &#8380;
            </Text>
          </Box>
          <Flex
            bg="gray.100"
            width="140px"
            p="8px 4px"
            alignItems="center"
            justifyContent="space-between"
            borderRadius="10px"
            margin="auto"
            mt={4}
          >
            <Button
              h="40px"
              w="40px"
              fontSize="20px"
              fontWeight={800}
              colorScheme="cyan"
              borderRadius="10px"
              isDisabled={watch(getName(i)) === 0 || !item.quantity}
              onClick={() => setValue(getName(i), watch(getName(i)) - 1)}
            >
              <MinusIcon />
            </Button>
            <Text>{watch(getName(i)) ?? "0"}</Text>
            <Button
              h="40px"
              w="40px"
              fontSize="20px"
              fontWeight={800}
              colorScheme="cyan"
              borderRadius="10px"
              isDisabled={watch(getName(i)) === item.quantity || !item.quantity}
              onClick={() => {
                const newValue = watch(getName(i)) + 1;
                if (newValue <= item.quantity) {
                  setValue(getName(i), newValue);
                }
                maxQuantityCheck(i, item.quantity);
              }}
            >
              <AddIcon w="20px" h="20px" />
            </Button>
          </Flex>
          {!item.quantity && (
            <Text mt="16px" color="red">
              {t("sold-out")}
            </Text>
          )}
        </Box>
      ))}
    </>
  );
};
